import { combineReducers } from '@reduxjs/toolkit'
import gameSetting from './slices/gameSettings.slice'
import authSlice from './slices/auth.slice'
import kenoGame from 'games/KenoGame/slice-thunk/kenoGame.slice'
import crashGame from 'games/CrashGame/slice-thunk/crashGame.slice'
import blackjackGame from 'games/BlackjackGame/slice-thunk/blackjack.slice'
import flipCoinGame from 'games/FlipCoinGame/slice-thunk/flipCoinGame.slice'
import hiLoGame from 'games/HiLoGame/slice-thunk/hiLoGame.slice'
import loader from './slices/loader.slice'
import rouletteGame from 'games/RouletteGame/rouletteGame.slice'

const rootReducer = combineReducers({
  gameSetting,
  crashGame,
  kenoGame,
  hiLoGame,
  blackjackGame,
  rouletteGame,
  flipCoinGame,
  auth: authSlice,
  loader
})

export default rootReducer
